var map = {
	"./alert.svg": "74e4",
	"./arrow.svg": "60ae",
	"./attached-file.svg": "b93b",
	"./back.svg": "a78c",
	"./bullet-blue.svg": "0885",
	"./bullet.svg": "f4bb",
	"./change.svg": "b403",
	"./clock.svg": "ea63",
	"./diagonal.png": "3a1a",
	"./eye.svg": "ff6e",
	"./lamp.png": "941d",
	"./nav.svg": "7d06",
	"./sheets.svg": "ecb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";